import React, { useEffect, useState } from 'react';
import Proptypes from 'prop-types';
import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { NOT_FETCHED } from '../../AddToConstants';
import {
  processListItemsForDataUpdate,
  processProductDataResponse
} from '../../../utils/copyLists.utils';

export const ProductsPropsFetcher = ({
  children,
  selectedListItems,
  updateBasePrice,
  updateSku,
  isProjects,
}) => {
  const BATCH_SIZE_LIMIT = 16;
  const { storeId, storeZip } = useStore({ varnish: true });
  const [itemPriceMap, setItemPriceMap] = useState(new Map());
  const [itemSkuMap, setItemSkuMap] = useState(new Map());
  const [
    fetchListProducts, { data: productData, variables, error }
  ] = useLazyDataModel('products', {});

  useEffect(() => {
    if (isProjects) {
      processListItemsForDataUpdate({
        selectedListItems,
        itemDataMap: itemSkuMap,
        fetchListProducts,
        updateFunction: updateSku,
        storeId,
        storeZip,
        filterCondition: (item) => item.sku === NOT_FETCHED,
        batchSizeLimit: BATCH_SIZE_LIMIT
      });
      return;
    }

    processListItemsForDataUpdate({
      selectedListItems,
      itemDataMap: itemPriceMap,
      fetchListProducts,
      updateFunction: updateBasePrice,
      storeId,
      storeZip,
      filterCondition: (item) => item.basePrice === NOT_FETCHED,
      batchSizeLimit: BATCH_SIZE_LIMIT
    });
  }, [selectedListItems]);

  useEffect(() => {
    if (isProjects) {
      processProductDataResponse({
        itemIds: variables?.itemIds,
        products: productData?.products,
        dataExtractor: (product) => {
          const storeSkuNumber = product?.identifiers?.storeSkuNumber;
          const omsThdSku = product?.identifiers?.omsThdSku;
          const specialOrderSku = product?.identifiers?.specialOrderSku;
          const sku = storeSkuNumber || omsThdSku || specialOrderSku;
          return sku;
        },
        updateFunction: updateSku,
        setDataMap: setItemSkuMap,
        error
      });
      return;
    }

    processProductDataResponse({
      itemIds: variables?.itemIds,
      products: productData?.products,
      dataExtractor: (product) => product?.pricing?.value || 'n/a',
      updateFunction: updateBasePrice,
      setDataMap: setItemPriceMap,
      error
    });
  }, [productData, error]);

  return (
    <>
      {
        children
      }
    </>
  );
};

ProductsPropsFetcher.propTypes = {
  children: Proptypes.node.isRequired,
  selectedListItems: Proptypes.objectOf(
    Proptypes.arrayOf(
      Proptypes.shape({
        itemId: Proptypes.string.isRequired,
        quantity: Proptypes.number.isRequired,
        sku: Proptypes.string.isRequired,
      })
    )
  ).isRequired,
  updateBasePrice: Proptypes.func.isRequired,
  updateSku: Proptypes.func.isRequired,
  isProjects: Proptypes.bool.isRequired,
};
